import { useEffect, useState } from "react";
import type { SectionId } from "@/lib/palette";
import { sectionIds } from "@/lib/palette";

/**
 * Track which section is currently in the viewport center.
 * Returns the SectionId of the active chapter, updated on scroll via IO.
 */
export function useChapterObserver(
  defaultSection: SectionId = "s01",
): SectionId {
  const [active, setActive] = useState<SectionId>(defaultSection);

  useEffect(() => {
    const observers: IntersectionObserver[] = [];

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.4) {
              setActive(id);
            }
          });
        },
        { threshold: [0.4] },
      );
      observer.observe(el);
      observers.push(observer);
    });

    return () => {
      observers.forEach((o) => o.disconnect());
    };
  }, []);

  return active;
}
